export const EXPERIMENTS = Object.freeze({
  GDPR_PLACING: 'gdpr_placing',
  BOOST_APPOINTMENT_CANCELLATION: 'boost_appointment_cancellation',
})

export const EXPERIMENT_VARIANTS = Object.freeze({
  [EXPERIMENTS.GDPR_PLACING]: {
    CONTROL: 'control',
    VARIANT_A: 'variant_A',
  },
  [EXPERIMENTS.BOOST_APPOINTMENT_CANCELLATION]: {
    CONTROL: 'control',
    VARIANT_A: 'variant_A',
    VARIANT_B: 'variant_B',
    VARIANT_C: 'variant_C',
  },
})
